import React from 'react';
import {Flex} from "../common_style/flex";
import {Colors, FontStyles} from "../constants";
import styled from 'styled-components';
import {Span} from "../common_style/text";
import {ReactComponent as ImagePlaceholder} from "../../assets/icons/image_placeholder.svg";
import {ReactComponent as Plus} from "../../assets/icons/plus.svg";
import {ReactComponent as Delete} from "assets/icons/delete.svg";
import {ReactComponent as Pdf} from "assets/icons/pdf.svg";
import {ReactComponent as Edit} from "assets/icons/edit.svg";
import {ReactComponent as Share} from "assets/icons/share.svg";
import {Localization} from "localizations/languages";

export const CardContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 400px;
    height: 225px;
    background-color: ${Colors.primaryShade};
    background-image: url("${props => props.bgImage}");;
    background-size: cover;
    margin: 20px;
    border-radius: 30px;
    cursor:pointer;
`;

export function NewStoryCardView(props) {
    return <CardContainer onClick={() => props.onClick()} style={{border: 'dashed 1px ' + Colors.button}}>
        <Plus style={{height: '45px', marginBottom: '5px'}}/>
        <Span textStyle={FontStyles.disabledPrimary}>{Localization.current.translation0}</Span>
    </CardContainer>
}

export function PlaceholderStoryCardView(props) {
    return <CardContainer onClick={() => props.onClick()} style={{border: 'solid 1px ' + Colors.button}}>
        <ImagePlaceholder style={{height: '45px', marginBottom: '5px'}}/>
        <Span textStyle={FontStyles.disabledPrimary}>{Localization.current.translation65}</Span>
    </CardContainer>
}


const iconStyle = {
    filter: 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4))', width: '20px', height: '20px', fill: 'white'
};

function StoryCardView(props) {
    return <CardContainer onClick={() => props.onClick()} {...props}>
        <div
            style={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                left: 0,
                top: 50,
                borderRadius: 30,
                background: 'linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(255,255,255,0) 100%)',
            }}>
            <Flex column wmax hmax vAlign={'flex-end'}>
                <Span style={{marginBottom: '3px', marginLeft: '30px'}}
                      textStyle={FontStyles.strongLight}>{props.title}</Span>
                <Span style={{marginBottom: '20px', marginLeft: '30px'}}
                      textStyle={FontStyles.italicLight}>{props.sharedFrom}</Span>
            </Flex>
        </div>
        {!props.shared ? <Flex
            style={{
                position: 'absolute',
                top: 20,
                right: 20,
            }}>
            <Edit onClick={(e) => {
                e.stopPropagation();
                props.onEdit();
            }} style={{
                marginRight: 10,
                ...iconStyle}}/>
            <Share onClick={(e) => {
                e.stopPropagation();
                props.onShare();
            }} style={iconStyle}/>
        </Flex> : null}
        {!props.shared ? <div
            onClick={(e) => {
                e.stopPropagation();
                props.onDelete();
            }}
            style={{
                position: 'absolute',
                top: 20,
                left: 20,
            }}>
            <Delete style={iconStyle}/>
        </div> : null}
        <div
            onClick={(e) => {
                e.stopPropagation();
                props.onPdf();
            }}
            style={{
                position: 'absolute',
                bottom: 20,
                right: 20,
            }}>
            <Pdf style={iconStyle}/>
        </div>
    </CardContainer>
}

export default StoryCardView;
